export default "__VITE_ASSET__f7f60743__"